/**
 * Sacred Library image paths — original SVGs in /public/images/sacred-library (CC0-style).
 * Sync image_url values with backend/acharya-ai/src/data/sacred-library-search.ts
 */

export const SACRED_IMAGE_BASE = "/images/sacred-library";

export const SACRED_IMAGE_URLS = {
  deities: {
    ganesha: `${SACRED_IMAGE_BASE}/deities/ganesha.svg`,
    shiva: `${SACRED_IMAGE_BASE}/deities/shiva.svg`,
    parvati: `${SACRED_IMAGE_BASE}/deities/parvati.svg`,
    vishnu: `${SACRED_IMAGE_BASE}/deities/vishnu.svg`,
    lakshmi: `${SACRED_IMAGE_BASE}/deities/lakshmi.svg`,
    saraswati: `${SACRED_IMAGE_BASE}/deities/saraswati.svg`,
    rama: `${SACRED_IMAGE_BASE}/deities/rama.svg`,
    krishna: `${SACRED_IMAGE_BASE}/deities/krishna.svg`,
    hanuman: `${SACRED_IMAGE_BASE}/deities/hanuman.svg`,
    narasimha: `${SACRED_IMAGE_BASE}/deities/narasimha.svg`,
    subrahmanya: `${SACRED_IMAGE_BASE}/deities/subrahmanya.svg`,
    durga: `${SACRED_IMAGE_BASE}/deities/durga.svg`,
    kali: `${SACRED_IMAGE_BASE}/deities/kali.svg`,
    ayyappa: `${SACRED_IMAGE_BASE}/deities/ayyappa.svg`,
  },
  festivals: {
    ugadi: `${SACRED_IMAGE_BASE}/festivals/ugadi.svg`,
    rama_navami: `${SACRED_IMAGE_BASE}/festivals/rama_navami.svg`,
    nrisimha_jayanti: `${SACRED_IMAGE_BASE}/festivals/nrisimha_jayanti.svg`,
    krishna_janmashtami: `${SACRED_IMAGE_BASE}/festivals/krishna_janmashtami.svg`,
    maha_shivaratri: `${SACRED_IMAGE_BASE}/festivals/maha_shivaratri.svg`,
    navaratri: `${SACRED_IMAGE_BASE}/festivals/navaratri.svg`,
    vijayadashami: `${SACRED_IMAGE_BASE}/festivals/vijayadashami.svg`,
    vaikuntha_ekadashi: `${SACRED_IMAGE_BASE}/festivals/vaikuntha_ekadashi.svg`,
    kartika_deepam: `${SACRED_IMAGE_BASE}/festivals/kartika_deepam.svg`,
    ganesh_chaturthi: `${SACRED_IMAGE_BASE}/festivals/ganesh_chaturthi.svg`,
  },
  vratas: {
    ekadashi: `${SACRED_IMAGE_BASE}/vratas/ekadashi.svg`,
    pradosham: `${SACRED_IMAGE_BASE}/vratas/pradosham.svg`,
    sankashti: `${SACRED_IMAGE_BASE}/vratas/sankashti.svg`,
    purnima: `${SACRED_IMAGE_BASE}/vratas/purnima.svg`,
    amavasya: `${SACRED_IMAGE_BASE}/vratas/amavasya.svg`,
    monthly_shivaratri: `${SACRED_IMAGE_BASE}/vratas/monthly_shivaratri.svg`,
  },
  stories: {
    markandeya: `${SACRED_IMAGE_BASE}/stories/markandeya.svg`,
    prahlada: `${SACRED_IMAGE_BASE}/stories/prahlada.svg`,
    dhruva: `${SACRED_IMAGE_BASE}/stories/dhruva.svg`,
    gajendra_moksha: `${SACRED_IMAGE_BASE}/stories/gajendra_moksha.svg`,
    krishna_leelas: `${SACRED_IMAGE_BASE}/stories/krishna_leelas.svg`,
    rama_stories: `${SACRED_IMAGE_BASE}/stories/rama_stories.svg`,
    shiva_purana_stories: `${SACRED_IMAGE_BASE}/stories/shiva_purana_stories.svg`,
  },
  sadhanas: {
    japa: `${SACRED_IMAGE_BASE}/sadhanas/japa.svg`,
    pranayama: `${SACRED_IMAGE_BASE}/sadhanas/pranayama.svg`,
    trataka: `${SACRED_IMAGE_BASE}/sadhanas/trataka.svg`,
    gayatri_sadhana: `${SACRED_IMAGE_BASE}/sadhanas/gayatri_sadhana.svg`,
    shiva_panchakshari: `${SACRED_IMAGE_BASE}/sadhanas/shiva_panchakshari.svg`,
    hanuman_sadhana: `${SACRED_IMAGE_BASE}/sadhanas/hanuman_sadhana.svg`,
  },
};

export const SACRED_FALLBACK_IMAGE = `${SACRED_IMAGE_BASE}/fallback.svg`;

/** @param {'deity'|'festival'|'vrata'|'story'|'sadhana'} catalogKey */
export function getSacredImageUrl(catalogKey, id) {
  const map = SACRED_IMAGE_URLS[catalogKey];
  return map?.[id] ?? SACRED_FALLBACK_IMAGE;
}

/** Attach image_url to catalog entries */
export function withSacredImages(catalogKey, entries) {
  return entries.map((entry) => ({
    ...entry,
    image_url: getSacredImageUrl(catalogKey, entry.id),
  }));
}

/** Resolve image for pañchāṅga-linked library id */
export function imageUrlForLibraryTopic(type, libraryId) {
  const key =
    type === "deity"
      ? "deities"
      : type === "festival"
        ? "festivals"
        : type === "vrata"
          ? "vratas"
          : type === "story"
            ? "stories"
            : type === "sadhana"
              ? "sadhanas"
              : null;
  if (!key || !libraryId) return SACRED_FALLBACK_IMAGE;
  return getSacredImageUrl(key, libraryId);
}
